import React, { useContext } from 'react';
import { Box, IconButton, Tooltip, useTheme } from '@mui/material';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import { ColorModeContext } from '../../theme';

export default function ThemeToggleButton({ variant = 'default', sx = {} }) {
  const theme = useTheme();
  const colorMode = useContext(ColorModeContext);

  const icon = theme.palette.mode === 'dark' ? <DarkModeOutlinedIcon /> : <LightModeOutlinedIcon />;
  const tooltip = `Gå til ${theme.palette.mode === 'dark' ? 'lyst' : 'mørkt (eksperimentelt)'} tema`;

  if (variant === 'outlined') {
    return (
      <Tooltip title={tooltip}>
        {/* Outer: transparent, extends touch area; m cancels the extra layout space */}
        <Box
          onClick={colorMode.toggleColorMode}
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            p: '8px',
            m: '-8px',
            ...sx,
          }}
        >
          <Box
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: 0.5,
              border: `1px solid ${theme.palette.divider}`,
              backgroundColor: theme.palette.action.hover,
              p: '4px',
              '&:hover': { backgroundColor: theme.palette.action.selected },
              pointerEvents: 'none',
            }}
          >
            {icon}
          </Box>
        </Box>
      </Tooltip>
    );
  }

  return (
    <Tooltip title={tooltip}>
      <IconButton onClick={colorMode.toggleColorMode} sx={sx}>
        {icon}
      </IconButton>
    </Tooltip>
  );
}
